<template>
  <div class="root">
    <component :is="componentIs" :class="classMap" :href="fileValue" target="_blank">
      <p class="title zero-mp" data-inspect="p">
        <cms-material-icon class="icon" v-if="blok.icon" :icon="blok.icon" :color="blok.icon_color"></cms-material-icon>
        <span class="inner">{{ blok.title }}</span>
      </p>
      <p class="text-sm mt-2" v-if="isPlainText">{{ blok.description }}</p>
      <AppRichText v-else class="description zero-mp rich-content" data-inspect="p" :content="blok.description" />
    </component>
  </div>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  name: "cms-info-box",
  mixins: [cms],
  computed: {
    isPlainText() {
      return typeof this.blok.description === "string"
    },
    componentIs() {
      return this.blok.file?.filename ? "a" : "div"
    },
    fileValue() {
      return this.blok.file ? this.blok.file?.filename : null
    },
    classMap() {
      return {
        "box": true,
        "accent-hover": this.blok.file?.filename,
        "has-icon": this.blok.icon != "none",
        "inline-title": this.blok.inline_title
      }
    }
  }
}
</script>

<style scoped>
.box {
  display: grid;
  grid-template-rows: max-content 1fr;
  height: 100%;
  padding: 0.8rem;
  border-radius: 8px;
  background-color: var(--crf-bg-high);
  box-shadow: var(--crf-shadow);
  font-family: var(--crf-ff);
  text-decoration: none;
}

p.title {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  color: var(--crf-flip);
  font-family: 'Inter';
  gap: 5px;

}

.inline-title p.title {
  align-items: center;
  flex-direction: row;
}


p.title span.inner {
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 700;
}

p.title span.icon {
  font-weight: 400;
}

p.description {
  color: var(--crf-text);
  font-size: 0.9rem;
  white-space: pre-line;
  padding: 0.45rem 0 0.2rem 0;
}
</style>
